exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button[data-v-2fd93a50] {\n    font-size: 11px !important;\n    text-align: left;\n}\n.secondary-btn[data-v-2fd93a50] {\n    background-color: #979797;\n}\n", ""]);

// exports
